import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { getAdminSession } from "./lib/adminAuth";
import { isAuthenticated } from "./lib/auth";
import { AdminHome } from "./pages/AdminHome";
import { AdminLogin } from "./pages/AdminLogin";
import { BlockDetail } from "./pages/BlockDetail";
import { EstateLandBlocks } from "./pages/EstateLandBlocks";
import { FieldOps } from "./pages/FieldOps";
import { HarvestPlanning } from "./pages/HarvestPlanning";
import { Login } from "./pages/Login";
import { MandorMobile } from "./pages/MandorMobile";
import { Mill } from "./pages/Mill";
import { MobilePreview } from "./pages/MobilePreview";
import { Manpower } from "./pages/Manpower";
import { SmartGrading } from "./pages/SmartGrading";
import { VehiclePlanning } from "./pages/VehiclePlanning";

/** Gate · unauthenticated visitors land on /login first. */
function RequireAuth() {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return <Outlet />;
}

/** Gate · Platform Admin console needs its own (separate) session. */
function RequireAdmin() {
  if (!getAdminSession()) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<RequireAdmin />}>
        <Route path="/admin" element={<AdminHome />} />
      </Route>
      <Route element={<RequireAuth />}>
      {/* Phone-first Mandor view · no desktop sidebar chrome */}
      <Route path="/mandor" element={<MandorMobile />} />
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/estate-land" replace />} />
        <Route path="/estate-land" element={<EstateLandBlocks />} />
        <Route path="/estate-land/blocks/:id" element={<BlockDetail />} />
        <Route path="/harvesting" element={<HarvestPlanning />} />
        <Route path="/smart-grading" element={<SmartGrading />} />
        <Route path="/delivery" element={<FieldOps />} />
        <Route path="/vehicle" element={<VehiclePlanning />} />
        <Route path="/manpower" element={<Manpower />} />
        <Route path="/mill" element={<Mill />} />
        <Route path="/mill-sales" element={<Placeholder title="Mill Sales" />} />
        <Route path="/subcontract" element={<Placeholder title="Subcontract / Tolling" />} />
        <Route path="/reports" element={<Placeholder title="Reports" />} />
        <Route path="/mobile" element={<MobilePreview />} />
        <Route path="*" element={<Placeholder title="Not found" />} />
      </Route>
      </Route>
    </Routes>
  );
}

function Placeholder({ title }: { title: string }) {
  return (
    <div className="text-sm">
      <div className="text-lg font-medium mb-2">{title}</div>
      <div className="text-xs text-text-secondary">
        This module is not implemented yet — see <code>docs/mockups/</code> for the design.
      </div>
    </div>
  );
}
